<template>

	<div id="wrapper">

        <div class="center">

            <div class="attention">Achtung</div>
            <p><strong>Der von Ihnen verwendete Browser ist leider veraltet.</strong></p>
            <p>Bitte verwenden Sie eine aktuelle Browserversion, um stets durch die notwendigen Sicherheitsupdates der Browserhersteller geschützt zu sein und um eine optimale Darstellung und Funktion der Apothekenkatalog-Plattform zu erhalten.</p>
            <p>Wir empfehlen Ihnen die Verwendung eines der folgenden Browser:</p>

            <ul>
                <li>Firefox  - in der aktuellen Version <a href="https://www.mozilla.org/de/firefox/new/">> hier kostenlos herunterladen</a></li>
                <li>Google Chrome – in der aktuellen Version <a href="https://www.google.de/chrome/browser/desktop/index.html">> hier kostenlos herunterladen</a></li>
                <li>Internet Explorer – ab Version 11 <a href="https://www.microsoft.com/de-at/download/internet-explorer.aspx">> hier kostenlos herunterladen</a></li>
                <li>Microsoft Edge – für Microsoft Windows 10 <a href="https://www.microsoft.com/de-at/windows/microsoft-edge">> hier kostenlos herunterladen</a></li>
                <li>Safari für OS X – in der aktuellen Version <a href="https://support.apple.com/de-at/HT204416">> hier kostenlos herunterladen</a></li>
            </ul>

            <p>Wenn Sie aus Unternehmens-internen Gründen selbst keinen neuen Browser installieren können, fragen Sie bitte Ihren Netzwerkadministrator nach einem Browser-Update.</p>

        </div>

    </div> <!-- // #wrapper -->


</template>



<script>

export default {

	name: 'oldBrowser',

	data() {
		return {

		}
	},

	mounted() {

	},

	computed: {

	},

	methods: {

    }

}
</script>


<style scoped>
body {
    font-size: 12px;
    font-family: verdana;
}
#wrapper {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	width: 100%;
	height: 100%;
	width: 100vw;
	height: 100vh;
	background-color: #fefefe;
    /*
	background: #fefefe url('../assets/img/bg_login.jpg') no-repeat 50% 50% !important;
	background-size: cover !important;
	*/
}
.center {
    width: 650px;
    height: auto;
    padding: 25px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -165px 0 0 -325px !important;
    background: rgba(255,255,255,0.8);
    border-radius: 4px;
	box-shadow: 1px 1px 10px rgba(0,0,0,0.1);
}
p {
    margin: 0 0 10px 0;
}
ul {
    margin: 0 0 10px 0;
}
ul li {
    list-style-type: circle;
    margin: 0 0 2px 25px;
}
.attention {
    margin: 0 0 15px 0;
    color: red;
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
    text-align: center;
}
a {
    color: #444;
    text-decoration: underline;
}
a:hover {
    color: #000;
    text-decoration: none;
}

</style>
